export default __webpack_public_path__ + "static/media/drugi.6ee9aa18.jpg";